<res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs"
    [requestInfo]="requestInfo" [responseCallback]="responseCallback" [pagerVisible]="false"
    [updateStatusType]="updateStatusType" [rowClassRules]="rowClassRules">
</res-generic-grid>
<ng-template #headerTemplate>
    <div>
        <div class="calculate-row">
            <span>Used: {{totalStorageUsed}}</span>
            <button type="button" data-automation-id="organization-settings-calculate-storage" class="secondary-button"
                (click)="calculateStorage()"  [disabled]="isCalculatingStorage" [ngClass]="isCalculatingStorage ? 'calculating' : ''">
                <i class="fa" [ngClass]="isCalculatingStorage ? 'fa-spinner fa-spin' : 'fa-refresh'"></i>
                {{isCalculatingStorage ? 'Calculating' : 'Calculate'}}
            </button>
            <span class="last-calculated-span">Last calculated on: {{lastCalculatedDate}}</span>
        </div>
        <span class="description-row">
            Description: {{storageDescription}}
        </span>
    </div>
</ng-template>